import React from 'react'
import Modal from 'react-modal'
import { useMutation } from '@apollo/client'
import addPostscriptToAnswer from '../mutations/add-postscript-to-answer'
import TextareaAutosize from 'react-autosize-textarea'

const className = {
  base: 'modal widest',
  afterOpen: 'modal-after-open',
  beforeClose: 'modal-before-close',
}

const overlayClassName = {
  base: 'overlay',
  afterOpen: 'overlay-after-open',
  beforeClose: 'overlay-before-close',
}

const wordCount = (text) => {
  if (!text) return 0
  return text.split(' ').filter((s) => /[A-z]+/.test(s)).length
}

function AdditionalThoughtsModal(props) {
  const [text, setText] = React.useState('')
  const [addPostscriptToAnswerMutation] = useMutation(addPostscriptToAnswer)

  const handleClose = (e) => {
    e.preventDefault()

    props.onClose(null)
  }

  const handleThoughtsChange = (e) => {
    setText(e.target.value)
  }

  const handleSave = (e) => {
    e.preventDefault()

    const { onClose, assignment } = props
    const variables = { text, id: assignment.answer.id }

    addPostscriptToAnswerMutation({
      variables: variables,
    }).then(() => {
      onClose()
      setText('')
    })
  }

  const { isOpen, assignment, id } = props
  const formClasses = true ? 'reflection-form active' : 'reflection-form'
  const submitted = false

  const { question, answer } = assignment
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      contentLabel={'Pulse Modal'}
      className={className}
      overlayClassName={overlayClassName}
    >
      <a className="close" onClick={handleClose}>
        Cancel
      </a>
      <form id={id} className={formClasses}>
        <div className="reflection-card add-more">
          <label>{question.text}</label>
          <div class="text">{answer.text}</div>
          <TextareaAutosize
            value={text || ''}
            placeholder="+  Add more"
            onChange={handleThoughtsChange}
          />
          <div className="word-count">Words: {wordCount(text)} / 450</div>
        </div>
        <div className="actions">
          <button onClick={handleSave}>
            {submitted ? <i className="material-icons">check</i> : 'Submit'}
          </button>
        </div>
      </form>
    </Modal>
  )
}

export default AdditionalThoughtsModal
